export default "__VITE_ASSET__Cbx$HkmP__"